import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeOCClaimsData } from './normalize';

export const fetchOCClaimsList = createProvider(api.fetchOCClaimsList)
  .andThen((res) => normalizeOCClaimsData(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
